var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{ 'primary-button': _vm.primary },attrs:{"type":"button"},on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }